import giftedReviewNotice from '@/components/gifted-review-notice/index.vue'

export default {
  name: 'ReviewsProductBlock',
  components: {
    giftedReviewNotice
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    forceHeight: {
      type: Number,
      default: 0
    }
  }
}
